import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandlerFn,
  HttpRequest,
  HttpStatusCode,
} from '@angular/common/http';
import {inject} from '@angular/core';
import {Store} from '@ngrx/store';
import {AuthenticationActions} from '@state/authentication/authentication.actions';
import {catchError, Observable, throwError} from 'rxjs';

export function unauthorizedInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const store = inject(Store);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
      if (error.status === HttpStatusCode.Unauthorized) {
        store.dispatch(AuthenticationActions.logout());
      }
      return throwError(() => error);
    })
  );
}
